export const Slug = process.env.REACT_APP_APP_CONTEXT;